<!--
 * @Author: 张天昊
 * @Date: 2024-05-17 11:25:06
 * @LastEditTime: 2024-05-27 16:48:40
 * @LastEditors: 张天昊
 * @Description: 复制按钮
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/CopyButton.vue
-->
<script>
import { defineComponent } from 'vue';
import { Toast } from 'vant';

export default defineComponent({
  props: {
    theme: {
      type: String,
      default: 'light'
    },
    value: {
      type: String,
      default: ''
    }
  },
  setup() {
    function onSuccess() {
      Toast.success('复制成功');
    }
    function onError() {
      Toast.success('复制失败');
    }
    return {
      onSuccess,
      onError
    };
  }
});
</script>

<template>
  <span
    class="inline-flex items-center text-12 leading-17 font-semibold van-haptics-feedback"
    :class="theme === 'light' ? 'text-white' : 'text-black-a'"
    v-clipboard:copy="value"
    v-clipboard:success="onSuccess"
    v-clipboard:error="onError"
    ><svg-icon
      pre-path="itineraryUniversal"
      name="ic-copy"
      class="w-12 h-12 mr-4"
    />复制</span
  >
</template>
